import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import {
  CreateFacebookCampaignMutation,
  CreateFacebookCampaignMutationVariables
} from './__generated__/CreateFacebookCampaignMutation';

const CREATE_FACEBOOK_CAMPAIGN_MUTATION = gql`
  mutation CreateFacebookCampaignMutation($facebookCampaignParams: FacebookCampaignParams!) {
    createFacebookCampaign(facebookCampaignParams: $facebookCampaignParams) {
      campaign {
        id
      }
      errors {
        attribute
        messages
        fullMessages
      }
    }
  }
`;

export const useCreateFacebookCampaign = () => {
  return useMutation<CreateFacebookCampaignMutation, CreateFacebookCampaignMutationVariables>(
    CREATE_FACEBOOK_CAMPAIGN_MUTATION,
    { client: kmsClient }
  );
};
